module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'f9e45g3j',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production',
    apiVersion: process.env.GATSBY_SANITY_API_VERSION || '2021-03-31',
  },
}
